import React from 'react'
import BasePortableText from '@sanity/block-content-to-react'

import styled from 'styled-components'
// import { clientConfig } from './client'

import { Box } from 'theme-ui'

const ContentWrapper = styled(Box)`
  // font-family: "Mallory Book", sans-serif;

  h1, h2, h3, h4, h5 {
    // font-family: "Mallory Book", sans-serif;
    color: #000;
    text-decoration: none;
    font-weight: bold;
  }
`

const serializers = {
  types: {
    code: (props) => (
      <pre data-language={props.node.language}>
        <code>{props.node.code}</code>
      </pre>
    ),
  },
}

const PortableText = (props) => {
  return (
    <ContentWrapper>
      <BasePortableText blocks={props.blocks} serializers={serializers} />
    </ContentWrapper>
  )
}

export default PortableText
